import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';

import { themeTop } from '../../../theme/system-utilities';
import Border from './index';

const UnstyledBorderTop = styled(Border)<any>`
  ${themeTop};
`;

const BorderTop = (props: ComponentProps<typeof UnstyledBorderTop>) => (
  <UnstyledBorderTop themeTop="sp_0" {...props} />
);

export default BorderTop;
